__turbopack_context__.v({
  "closeButton": "pg1FUa_closeButton",
  "container": "pg1FUa_container",
  "content": "pg1FUa_content",
  "detailsContainer": "pg1FUa_detailsContainer",
  "detailsIcon": "pg1FUa_detailsIcon",
  "detailsItem": "pg1FUa_detailsItem",
  "detailsItemContent": "pg1FUa_detailsItemContent",
  "detailsItemLabel": "pg1FUa_detailsItemLabel",
  "detailsItemWrapper": "pg1FUa_detailsItemWrapper",
  "detailsTable": "pg1FUa_detailsTable",
  "detailsTableRow": "pg1FUa_detailsTableRow",
  "dwellBlock": "pg1FUa_dwellBlock",
  "dwellDiffTime": "pg1FUa_dwellDiffTime",
  "eventsContainer": "pg1FUa_eventsContainer",
  "eventsContainerHeader": "pg1FUa_eventsContainerHeader",
  "eventsContainerHeaderLabel": "pg1FUa_eventsContainerHeaderLabel",
  "header": "pg1FUa_header",
  "reportButton": "pg1FUa_reportButton",
  "tableRow": "pg1FUa_tableRow",
  "tableRowCurrentlyInside": "pg1FUa_tableRowCurrentlyInside",
  "tableRowPlateAndAvatar": "pg1FUa_tableRowPlateAndAvatar",
  "title": "pg1FUa_title",
});
